import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs';

export interface AppSettings {
  authority: string;
  clientId: string;
  loginRedirectUrl: string;
  oldExperienceUrl: string;
  oldMobileExperienceUrl: string;
  baseUrl: string;
  appToken: string;
  translationsUrl: string;
  tenantId: string;
}

@Injectable()
export class AppSettingsService {
  public appSettings: AppSettings;
  private httpClient: HttpClient;

  constructor(httpBackend: HttpBackend) {
    // Bypass interceptors by creating new HttpClient
    this.httpClient = new HttpClient(httpBackend);
  }

  loadAppSettings() {
    return this.httpClient.get<AppSettings>('/assets/configs/appsettings.json').pipe(tap((appSettings) => (this.appSettings = appSettings)));
  }
}
